import { canManageTeam } from '../../constants/roles';

const DEFAULT_CHILD_CHAT_ROLES = new Set([
  'care_owner',
  'care_partner',
  'caregiver',
]);

const CUSTOM_CHAT_PARTICIPANT_ROLES = new Set([
  'care_owner',
  'care_partner',
  'caregiver',
  'therapist',
]);

export const getChildRoleForMessaging = (childrenWithAccess = [], childId = null) => (
  childrenWithAccess.find((child) => child.id === childId)?.userRole || null
);

export const canOpenDefaultChildChat = (userRole) => DEFAULT_CHILD_CHAT_ROLES.has(userRole);

export const canCreateCustomChildChat = (userRole) => canManageTeam(userRole);

export const canStartChildCareTeamChat = canCreateCustomChildChat;

export const getManageableMessagingChildren = (childrenWithAccess = []) => (
  childrenWithAccess.filter((child) => canCreateCustomChildChat(child.userRole))
);

export const filterChildChatParticipants = (contacts = [], currentUserId = null) => (
  contacts.filter((contact) => (
    contact?.userId &&
    contact.userId !== currentUserId &&
    CUSTOM_CHAT_PARTICIPANT_ROLES.has(contact.role)
  ))
);

export const getChildChatAccessHint = (userRole, childName = 'this child') => {
  if (canCreateCustomChildChat(userRole)) {
    return `Message everyone supporting ${childName}.`;
  }

  if (canOpenDefaultChildChat(userRole)) {
    return `You can participate in ${childName}'s general care chat, but only the Care Owner or Care Partner can start custom chats.`;
  }

  return `You can join specific chats when a Care Owner or Care Partner adds you.`;
};
